<template>
  <div class="material-page">
    <div class="record-list-wrap">
      <div class="record-top">
        <div class="date-filter">
          <div class="date-row">
            <span class="date-label">时间</span>
            <span class="date-value" @click="openRecordDateRangePicker">{{ recordDateRange.start || "开始日期" }}</span>
            <span class="date-sep">-</span>
            <span class="date-value" @click="openRecordDateRangePicker">{{ recordDateRange.end || "结束日期" }}</span>
            <span
              v-if="recordDateRange.start || recordDateRange.end"
              class="date-clear"
              @click="clearRecordDateRange"
            >
              清空
            </span>
          </div>
        </div>
        <div class="type-tabs record-filters">
          <van-tabs v-model="listType" swipeable @change="onListTypeChange">
            <van-tab v-for="opt in listTypeOptions" :key="String(opt.value)" :title="opt.label" :name="opt.value" />
          </van-tabs>
        </div>
        <div v-if="isSubmittedTab" class="record-filters">
          <van-tabs v-model="recordStatus" swipeable @change="onRecordStatusChange">
            <van-tab v-for="opt in recordStatusOptions" :key="String(opt.value)" :title="opt.label" :name="opt.value" />
          </van-tabs>
        </div>
      </div>
      <van-pull-refresh v-model="recordRefreshing" @refresh="onRecordRefresh">
        <van-list
          v-model="recordLoading"
          :finished="recordFinished"
          :error.sync="recordError"
          error-text="加载失败，点击重试"
          finished-text="没有更多了"
          @load="onRecordLoad"
        >
          <div class="records-wrap">
            <van-empty
              v-if="applyRecords.length === 0 && !recordLoading && !recordError"
              image="search"
              :description="listEmptyText"
              class="panel-empty"
            />
            <template v-if="isSubmittedTab">
            <div
              v-for="item in applyRecords"
              :key="item.id || item.applyId"
              :class="['record-card', 'record-booking-card', applyRecordCardClass(item)]"
            >
              <div class="record-card-head">
                <span class="record-card-title">{{ item.applyName || "-" }}</span>
                <van-tag v-if="applyRecordStatusText(item)" :class="['status-tag', applyRecordStatusClass(item)]">
                  {{ applyRecordStatusText(item) }}
                </van-tag>
              </div>
              <div class="record-card-body">
                <div class="record-row">
                  <span class="record-label">中心</span>
                  <span class="record-value">{{ item.topDepartmentName || item.topDepartmentId || "-" }}</span>
                </div>
                <div v-if="studentBookGroups(item).length" class="record-books-block">
                  <div class="record-section-title">申请明细</div>
                  <div v-for="group in studentBookGroups(item)" :key="group.key" class="record-student-block">
                    <div class="record-student-title">{{ group.studentName }}</div>
                    <div class="record-course-books">
                      <span v-for="book in group.books" :key="book.key" class="record-book-chip">
                        {{ book.bookName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="item.remark" class="record-row">
                  <span class="record-label">备注</span>
                  <span class="record-value">{{ item.remark }}</span>
                </div>
                <div v-if="showApproveInfo(item)" class="record-row">
                  <span class="record-label">审批人</span>
                  <span class="record-value">{{ item.approverName || "-" }}</span>
                </div>
                <div v-if="showApproveInfo(item) && item.approveTime" class="record-row">
                  <span class="record-label">审批时间</span>
                  <span class="record-value">{{ item.approveTime }}</span>
                </div>
                <div v-if="showRejectReason(item)" class="record-row">
                  <span class="record-label">驳回原因</span>
                  <span class="record-value">{{ item.rejectReason }}</span>
                </div>
                <div v-if="showToCenterTime(item)" class="record-row">
                  <span class="record-label">移交中心时间</span>
                  <span class="record-value">{{ item.toCenterTime }}</span>
                </div>
                <div v-if="showIssuedSummary(item)" class="record-row">
                  <span class="record-label">发放进度</span>
                  <span class="record-value">{{ issuedSummary(item) }}</span>
                </div>
                <div class="record-row">
                  <span class="record-label">申请时间</span>
                  <span class="record-value">{{ item.createTime || item.applyTime || "-" }}</span>
                </div>
                <div v-if="Number(item.status) === 1" class="record-actions">
                  <van-button
                    round
                    block
                    plain
                    type="danger"
                    class="record-cancel-btn"
                    :loading="recordCancelingId === String(item.id || item.applyId)"
                    @click="cancelApply(item)"
                  >
                    取消申请
                  </van-button>
                </div>
                <div v-else-if="Number(item.status) === 4" class="record-actions">
                  <van-button
                    round
                    block
                    type="primary"
                    class="record-issue-btn"
                    @click="openIssueDialog(item, false)"
                  >
                    发放教材
                  </van-button>
                </div>
                <div v-else-if="Number(item.status) === 5" class="record-actions">
                  <van-button
                    round
                    block
                    type="primary"
                    class="record-issue-btn"
                    @click="openIssueDialog(item, true)"
                  >
                    继续发放
                  </van-button>
                </div>
                <div v-if="[5, 6].includes(Number(item.status))" class="record-actions">
                  <van-button
                    round
                    block
                    plain
                    type="primary"
                    class="record-detail-btn"
                    @click="openIssuedDetail(item)"
                  >
                    教材发放详情
                  </van-button>
                </div>
              </div>
            </div>
            </template>
            <template v-else>
            <div
              v-for="item in applyRecords"
              :key="item.id || item.applyId"
              :class="['record-card', 'record-booking-card', auditCardStatusClass(item.status)]"
            >
              <div class="record-card-head">
                <div class="record-card-title-wrap">
                  <div class="record-card-title">{{ item.createName }}</div>
                  <div class="record-card-subtitle">{{ item.topDepartmentName || item.topDepartmentId || "-" }}</div>
                </div>
                <van-tag :class="['status-tag', auditStatusClass(item.status)]">{{ auditStatusText(item.status) }}</van-tag>
              </div>
              <div class="record-card-body">
                <div v-if="studentBookGroups(item).length" class="record-books-block">
                  <div class="record-section-title">申请明细</div>
                  <div v-for="group in studentBookGroups(item)" :key="`${item.id}_${group.key}`" class="record-student-block">
                    <div class="record-student-title">{{ group.studentName }}</div>
                    <div class="record-course-books">
                      <span
                        v-for="(book, bidx) in group.books"
                        :key="`${item.id}_${group.key}_${bidx}`"
                        class="record-book-chip"
                      >
                        {{ book.bookName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="item.remark" class="record-row">
                  <span class="record-label">备注</span>
                  <span class="record-value">{{ item.remark }}</span>
                </div>
                <div class="record-row">
                  <span class="record-label">申请时间</span>
                  <span class="record-value">{{ item.createTime || item.applyTime || "-" }}</span>
                </div>
                <div v-if="showApproveInfo(item)" class="record-row">
                  <span class="record-label">审批人</span>
                  <span class="record-value">{{ item.approverName || "-" }}</span>
                </div>
                <div v-if="showApproveInfo(item) && item.approveTime" class="record-row">
                  <span class="record-label">审批时间</span>
                  <span class="record-value">{{ item.approveTime }}</span>
                </div>
                <div v-if="showRejectReason(item)" class="record-row">
                  <span class="record-label">驳回原因</span>
                  <span class="record-value">{{ item.rejectReason }}</span>
                </div>
              </div>
              <div v-if="isPendingTab && Number(item.status) === 1" class="audit-actions">
                <van-button
                  round
                  block
                  plain
                  type="danger"
                  class="action-btn action-btn-reject"
                  :loading="rejectingId === (item.id || item.applyId)"
                  @click="rejectAudit(item)"
                >
                  拒绝
                </van-button>
                <van-button
                  round
                  block
                  type="primary"
                  class="action-btn action-btn-approve"
                  :loading="approvingId === (item.id || item.applyId)"
                  @click="approveAudit(item)"
                >
                  同意
                </van-button>
              </div>
              <div v-else-if="isPendingTab && Number(item.status) === 2" class="audit-actions single-action">
                <van-button
                  round
                  block
                  type="primary"
                  class="action-btn action-btn-approve"
                  :loading="centeringId === (item.id || item.applyId)"
                  @click="openToCenterDialog(item)"
                >
                  已转交中心
                </van-button>
              </div>
            </div>
            </template>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div v-if="isSubmittedTab" class="page-bottom-bar">
      <van-button round block type="primary" class="theme-btn" @click="openApplyFlow">
        教材申请
      </van-button>
    </div>

    <!-- 发起申请：选学员 + 选教材 -->
    <van-popup v-model="applyFlow.show" position="bottom" round :z-index="1000" :style="{ height: '92vh' }">
      <div class="apply-flow-inner">
        <div class="popup-head">
          <div class="popup-title">教材申请</div>
          <van-icon name="cross" class="popup-close" @click="closeApplyFlow" />
        </div>

        <div class="apply-picker-body">
          <div class="student-panel">
            <div class="panel-title">学员</div>
            <div class="student-side-list">
              <van-empty v-if="!applyFlow.students.length" description="请添加学员" class="panel-empty" />
              <template v-else>
                <div
                  v-for="stu in applyFlow.students"
                  :key="stu.studentId"
                  :class="['course-item', 'student-side-item', { active: String(activeStudentId) === String(stu.studentId) }]"
                  @click="selectApplyStudent(stu)"
                >
                  <div class="student-item-content">
                    <div class="course-item-name">{{ stu.label }}</div>
                    <div class="student-item-sub">已选 {{ (stu.selectedBooks || []).length }} 本</div>
                  </div>
                  <van-icon name="cross" class="student-remove-icon" @click.stop="removeApplyStudent(stu)" />
                </div>
              </template>
            </div>
            <div class="student-panel-foot">
              <van-button size="small" type="primary" plain block class="theme-btn-plain" @click="openStudentPicker">
                添加学员
              </van-button>
            </div>
          </div>

          <div class="book-panel">
            <div class="book-panel-scroll">
              <div class="book-panel-head">
                <div class="panel-title">教材</div>
                <van-checkbox
                  v-if="books.length && activeStudentId"
                  v-model="selectAllBooks"
                  icon-size="16px"
                  class="select-all-check"
                  @click.native.stop
                >
                  全选
                </van-checkbox>
              </div>
              <div v-if="!activeStudentId" class="panel-hint">请先选择学员</div>
              <div v-else-if="courseLoading || bookLoading" class="panel-loading">
                <van-loading size="20px" />
              </div>
              <van-empty v-else-if="books.length === 0" description="暂无教材" class="panel-empty" />
              <div v-else class="book-list">
                <div
                  v-for="book in books"
                  :key="book.id"
                  :class="['book-row', { selected: isBookSelected(book.id) }]"
                  @click="toggleBookSelect(book)"
                >
                  <van-checkbox
                    :value="isBookSelected(book.id)"
                    icon-size="16px"
                    class="book-check"
                    @click.native.stop="toggleBookSelect(book)"
                  />
                  <span class="book-row-name">{{ bookTitle(book) }}</span>
                  <span class="book-row-stock">{{ formatStockQty(book.stockQty) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="apply-flow-footer">
          <van-field
            v-model.trim="applyFlow.remark"
            label="备注"
            type="textarea"
            rows="1"
            autosize
            maxlength="200"
            placeholder="选填"
          />
          <div class="apply-footer-actions">
            <span class="apply-selected-tip">共 {{ totalSelectedBookCount }} 本</span>
            <van-button
              round
              type="primary"
              class="theme-btn apply-submit-btn"
              :loading="applyFlow.submitting"
              :disabled="!canSubmitApply"
              @click="submitApply"
            >
              提交申请
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="studentPicker.show" position="bottom" round :style="{ height: '70vh' }">
      <div class="student-picker-inner">
        <div class="popup-head">
          <div class="popup-title">选择学员</div>
          <van-icon name="cross" class="popup-close" @click="studentPicker.show = false" />
        </div>
        <van-search
          v-model="studentPicker.keyword"
          placeholder="搜索学员姓名/家长/手机号"
          shape="round"
          @search="onStudentSearch"
          @input="onStudentKeywordInput"
        />
        <div class="student-list-wrap">
          <van-list
            v-model="studentPicker.loading"
            :finished="studentPicker.finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onStudentPickerLoad"
          >
            <van-empty v-if="!studentPicker.loading && studentPicker.list.length === 0" description="暂无学员" class="panel-empty" />
            <div
              v-for="stu in studentPicker.list"
              :key="stu.studentId"
              :class="['student-item', { active: isStudentSelected(stu.studentId) }]"
              @click="toggleStudent(stu)"
            >
              <div class="student-item-name">{{ stu.stuName || "-" }}</div>
              <div class="student-item-sub">{{ stu.name || "-" }} {{ stu.mobile || "" }}</div>
            </div>
          </van-list>
        </div>
        <div class="student-picker-actions">
          <span class="student-picker-tip">已选 {{ applyFlow.students.length }} 人</span>
          <van-button round block type="primary" class="theme-btn student-picker-confirm-btn" @click="confirmStudentPicker">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="issueDialog.show" position="bottom" round :style="{ height: '72vh' }" @close="closeIssueDialog">
      <div class="issue-popup">
        <div class="popup-head">
          <div class="popup-title">发放教材</div>
          <van-icon name="cross" class="popup-close" @click="closeIssueDialog" />
        </div>
        <div class="issue-body">
          <van-field
            v-model.trim="issueDialog.issuedTime"
            label="发放时间"
            placeholder="YYYY-MM-DD HH:mm"
            is-link
            @click="openIssuedTimePicker"
            @blur="onIssuedTimeBlur"
          />
          <div class="issue-section-title">选择教材</div>
          <van-checkbox-group v-model="issueDialog.selectedIds" class="issue-student-list">
            <div v-for="stu in issueDialog.studentGroups" :key="stu.key" class="issue-group-block">
              <div class="issue-group-head">
                <div class="issue-group-title">学员：{{ stu.studentName }}</div>
                <span class="issue-select-toggle" @click.stop="toggleStudentSelectAll(stu)">
                  <van-icon :name="isStudentAllSelected(stu) ? 'checked' : 'circle'" class="issue-select-icon" />
                  {{ isStudentAllSelected(stu) ? "取消" : "全选" }}
                </span>
              </div>
              <div v-for="book in stu.bookList" :key="book.id" class="issue-student-item">
                <van-checkbox :name="book.id">{{ book.label }}</van-checkbox>
              </div>
            </div>
          </van-checkbox-group>
        </div>
        <div class="issue-footer">
          <van-button
            round
            block
            type="primary"
            class="record-issue-btn"
            :loading="issuing"
            @click="submitIssueBooks"
          >
            确认发放
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="issueDialog.timePickerShow" position="bottom">
      <van-datetime-picker
        v-model="issueDialog.pickerValue"
        type="datetime"
        title="选择发放时间"
        :min-date="recordDateRangePickerMinDate"
        :max-date="recordDateRangePickerMaxDate"
        @cancel="issueDialog.timePickerShow = false"
        @confirm="onConfirmIssuedTime"
      />
    </van-popup>

    <van-popup v-model="issuedDetailDialog.show" position="bottom" round :style="{ height: '70vh' }" @close="closeIssuedDetail">
      <div class="issue-popup">
        <div class="popup-head">
          <div class="popup-title">教材发放详情</div>
          <van-icon name="cross" class="popup-close" @click="closeIssuedDetail" />
        </div>
        <div class="issue-body">
          <van-empty v-if="issuedDetailDialog.groups.length === 0" description="暂无发放详情" class="panel-empty" />
          <div v-else class="issue-student-list">
            <div v-for="stu in issuedDetailDialog.groups" :key="stu.key" class="issue-group-block">
              <div class="issue-group-title">学员：{{ stu.studentName }}</div>
              <div
                v-for="(book, idx) in stu.bookList"
                :key="`${book.id || book.bookName}_${idx}`"
                :class="['issued-detail-item', Number(book.status) === 1 ? 'issued-detail-item-issued' : 'issued-detail-item-unissued']"
              >
                <div class="record-row">
                  <span class="record-label">教材名</span>
                  <span class="record-value">{{ book.bookName || "-" }}</span>
                </div>
                <div class="record-row">
                  <span class="record-label">状态</span>
                  <span :class="['record-value', Number(book.status) === 1 ? 'issued-status-issued' : 'issued-status-unissued']">
                    {{ issuedStatusText(book.status) }}
                  </span>
                </div>
                <div class="record-row">
                  <span class="record-label">发放时间</span>
                  <span class="record-value">{{ book.issuedTime || "-" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-dialog
      v-model="auditRejectDialog.show"
      title="拒绝原因"
      show-cancel-button
      confirm-button-text="确认拒绝"
      cancel-button-text="取消"
      @confirm="onConfirmAuditReject"
    >
      <div class="reject-dialog-body">
        <van-field
          v-model.trim="auditRejectDialog.reason"
          type="textarea"
          rows="3"
          autosize
          maxlength="200"
          placeholder="请输入拒绝原因（选填）"
        />
      </div>
    </van-dialog>

    <van-dialog
      v-model="toCenterDialog.show"
      title="转交中心"
      show-cancel-button
      confirm-button-text="确认转交"
      cancel-button-text="取消"
      @confirm="submitToCenter"
    >
      <div class="reject-dialog-body">
        <van-field
          v-model.trim="toCenterDialog.toCenterTime"
          label="转交时间"
          placeholder="YYYY-MM-DD HH:mm"
          is-link
          @click="openToCenterTimePicker"
          @blur="onToCenterTimeBlur"
        />
      </div>
    </van-dialog>

    <van-popup v-model="toCenterDialog.timePickerShow" position="bottom">
      <van-datetime-picker
        v-model="toCenterDialog.pickerValue"
        type="datetime"
        title="选择转交时间"
        :min-date="recordDateRangePickerMinDate"
        :max-date="recordDateRangePickerMaxDate"
        @cancel="toCenterDialog.timePickerShow = false"
        @confirm="onConfirmToCenterTime"
      />
    </van-popup>

    <van-calendar
      v-model="recordDateRangePickerShow"
      type="range"
      :min-date="recordDateRangePickerMinDate"
      :max-date="recordDateRangePickerMaxDate"
      :allow-same-day="true"
      :show-confirm="true"
      :default-date="recordDateRangePickerDefault"
      :z-index="5000"
      color="rgb(242, 124, 52)"
      @close="recordDateRangePickerShow = false"
      @confirm="onConfirmRecordDateRange"
    />
  </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import {
  applyBookStock,
  fetchBookApplyList,
  fetchBookApplyApprovalList,
  fetchBookApplyStudentCourse,
  approveBookApplyCancel,
  approveBookApplyPass,
  approveBookApplyReject,
  toCenterBookApply,
  issuedBookApply
} from "@/api/book"
import { ensureCurrentStaffProfile, getCurrentTopDepartmentId } from "@/store/currentStaff"
import { resetPageScrollAfterPaint } from "@/utils/scroll"

function normalizeList(res) {
  if (Array.isArray(res)) return res
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res?.list)) return res.list
  return []
}

export default {
  name: "MaterialApproval",
  data() {
    return {
      applyRecords: [],
      recordLoading: false,
      recordRefreshing: false,
      recordError: false,
      scrollToTopAfterLoad: false,
      recordFinished: false,
      recordPage: 1,
      recordPageSize: 20,
      listType: 1,
      listTypeOptions: [
        { label: "已提交", value: 1 },
        { label: "待处理", value: 2 },
        { label: "已处理", value: 3 }
      ],
      recordStatus: "all",
      recordDateRange: {
        start: "",
        end: ""
      },
      recordDateRangePickerShow: false,
      recordDateRangePickerMinDate: new Date(1970, 0, 1),
      recordDateRangePickerMaxDate: new Date(2100, 11, 31),
      recordStatusOptions: [
        { label: "全部", value: "all" },
        { label: "审批中", value: 1 },
        { label: "已同意", value: 2 },
        { label: "已拒绝", value: 3 },
        { label: "已转交中心", value: 4 },
        { label: "部分发放", value: 5 },
        { label: "已发放", value: 6 },
        { label: "已取消", value: 7 }
      ],
      recordCancelingId: "",
      approvingId: "",
      rejectingId: "",
      centeringId: "",
      auditRejectDialog: {
        show: false,
        id: "",
        reason: ""
      },
      toCenterDialog: {
        show: false,
        id: "",
        toCenterTime: "",
        timePickerShow: false,
        pickerValue: new Date()
      },
      issuing: false,
      issueDialog: {
        show: false,
        bookOptions: [],
        studentGroups: [],
        selectedIds: [],
        issuedTime: "",
        timePickerShow: false,
        pickerValue: new Date()
      },
      issuedDetailDialog: {
        show: false,
        groups: []
      },
      loginTopDepartmentId: null,
      loginStaffLoading: false,
      applyFlow: {
        show: false,
        id: null,
        students: [],
        remark: "",
        submitting: false
      },
      books: [],
      activeStudentId: null,
      studentPicker: {
        show: false,
        keyword: "",
        list: [],
        loading: false,
        requesting: false,
        finished: false,
        page: 1,
        pageSize: 20,
        keywordTimer: null
      }
    }
  },
  computed: {
    recordDateRangePickerDefault() {
      const { start, end } = this.recordDateRange
      if (!start && !end) return []
      const s = start ? this.parseDateOnly(start) : null
      const e = end ? this.parseDateOnly(end) : null
      if (s && e) return [s, e]
      return s ? [s, s] : []
    },
    selectAllBooks: {
      get() {
        if (!this.books.length || !this.activeStudentId) return false
        return this.books.every(b => this.isBookSelected(b.id))
      },
      set(val) {
        const stu = this.getActiveStudent()
        if (!stu) return
        if (val) {
          this.books.forEach(b => this.addSelectedBookForStudent(stu, b))
        } else {
          const ids = new Set(this.books.map(b => String(b.id)))
          this.$set(
            stu,
            "selectedBooks",
            (stu.selectedBooks || []).filter(b => !ids.has(String(b.id)))
          )
        }
      }
    },
    totalSelectedBookCount() {
      return this.applyFlow.students.reduce((sum, stu) => sum + (stu.selectedBooks?.length || 0), 0)
    },
    canSubmitApply() {
      return (
        this.loginTopDepartmentId &&
        this.applyFlow.students.length > 0 &&
        this.applyFlow.students.every(stu => (stu.selectedBooks?.length || 0) > 0) &&
        !this.applyFlow.submitting
      )
    },
    isSubmittedTab() {
      return Number(this.listType) === 1
    },
    isPendingTab() {
      return Number(this.listType) === 2
    },
    isProcessedTab() {
      return Number(this.listType) === 3
    },
    listEmptyText() {
      if (this.isSubmittedTab) return "暂无申请记录"
      if (this.isPendingTab) return "暂无待处理数据"
      return "暂无已处理数据"
    }
  },
  mounted() {
    const qType = String(this.$route?.query?.type || "").trim()
    if (qType === "approval") {
      this.listType = 2
    }
    this.onRecordRefresh()
    this.ensureLoginStaffInfo()
  },
  methods: {
    bookTitle(book) {
      return book?.bookName || book?.name || book?.title || "-"
    },
    formatStockQty(v) {
      if (v === null || v === undefined || v === "") return "-"
      const n = Number(v)
      return Number.isFinite(n) ? String(n) : String(v)
    },
    applyRecordStatusText(item) {
      const s = Number(item?.status)
      const map = {
        1: "审批中",
        2: "已同意",
        3: "已拒绝",
        4: "已转交中心",
        5: "部分发放学生",
        6: "已发放学生",
        7: "已取消"
      }
      return map[s] || ""
    },
    applyRecordStatusClass(item) {
      const s = Number(item?.status)
      if (s === 1) return "status-pending"
      if (s === 2 || s === 4 || s === 5 || s === 6) return "status-approved"
      if (s === 3) return "status-rejected"
      if (s === 7) return "status-cancel"
      return ""
    },
    applyRecordCardClass(item) {
      const s = Number(item?.status)
      if (s === 1) return "card-pending"
      if (s === 2 || s === 4 || s === 5 || s === 6) return "card-approved"
      if (s === 3) return "card-rejected"
      if (s === 7) return "card-cancel"
      return ""
    },
    studentNames(item) {
      const list = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      const names = list.map(x => (x?.studentName || "").trim()).filter(Boolean)
      return names.length ? names.join("、") : "-"
    },
    flattenBookNums(item) {
      const result = []
      const students = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      students.forEach(stu => {
        const courses = Array.isArray(stu?.courseList) ? stu.courseList : []
        courses.forEach(course => {
          const courseId = course?.courseId ?? "unknown"
          const courseName = (course?.courseName || "").trim() || `教程${courseId}`
          const books = Array.isArray(course?.bookNumList) ? course.bookNumList : []
          books.forEach(book => {
            result.push({
              courseId,
              courseName,
              bookName: book?.bookName || "-",
              num: Number(book?.num ?? 0),
              status: Number(book?.status ?? 0),
              issuedTime: book?.issuedTime || ""
            })
          })
        })
      })
      return result
    },
    studentBookGroups(item) {
      const students = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      return students
        .map((stu, idx) => {
          const studentName = (stu?.studentName || "").trim() || `学员${stu?.studentId ?? stu?.id ?? idx + 1}`
          const bookMap = new Map()
          const courses = Array.isArray(stu?.courseList) ? stu.courseList : []
          courses.forEach(course => {
            const bookNumList = Array.isArray(course?.bookNumList) ? course.bookNumList : []
            const bookIdList = Array.isArray(course?.bookIdList) ? course.bookIdList : []
            if (bookNumList.length) {
              bookNumList.forEach(book => {
                const bookName = (book?.bookName || "").trim() || `教材${book?.bookId ?? ""}` || "教材"
                const bk = bookMap.get(bookName) || { key: bookName, bookName, num: 0 }
                bk.num += Number(book?.num || 0) || 1
                bookMap.set(bookName, bk)
              })
              return
            }
            bookIdList.forEach(bookId => {
              const bookName = `教材${bookId}`
              const bk = bookMap.get(bookName) || { key: bookName, bookName, num: 0 }
              bk.num += 1
              bookMap.set(bookName, bk)
            })
          })
          return {
            key: String(stu?.studentId ?? stu?.id ?? idx),
            studentName,
            books: Array.from(bookMap.values())
          }
        })
        .filter(g => g.books.length > 0)
    },
    showApproveInfo(item) {
      return [2, 3, 4, 5, 6].includes(Number(item?.status))
    },
    showRejectReason(item) {
      return Number(item?.status) === 3 && !!item?.rejectReason
    },
    showToCenterTime(item) {
      return Number(item?.status) === 4 && !!item?.toCenterTime
    },
    showIssuedSummary(item) {
      return [5, 6].includes(Number(item?.status))
    },
    async cancelApply(item) {
      const id = item?.id || item?.applyId
      if (!id) return Toast.fail("缺少申请ID")
      try {
        await Dialog.confirm({
          message: "确定取消申请?"
        })
      } catch (e) {
        return
      }
      this.recordCancelingId = String(id)
      try {
        await approveBookApplyCancel({ id })
        Toast.success("已取消申请")
        this.onRecordRefresh()
      } finally {
        this.recordCancelingId = ""
      }
    },
    issuedSummary(item) {
      const rows = this.flattenBookNums(item)
      if (!rows.length) return "-"
      const issued = rows.filter(x => x.status === 1).length
      const total = rows.length
      return `${issued}/${total} 已发放`
    },
    getActiveStudent() {
      if (!this.activeStudentId) return null
      return this.applyFlow.students.find(stu => String(stu.studentId) === String(this.activeStudentId)) || null
    },
    isBookSelected(id) {
      const stu = this.getActiveStudent()
      if (!stu) return false
      return (stu.selectedBooks || []).some(x => String(x.id) === String(id))
    },
    addSelectedBookForStudent(stu, book) {
      if (!stu || !book?.id) return
      const list = stu.selectedBooks || []
      if (list.some(x => String(x.id) === String(book.id))) return
      this.$set(stu, "selectedBooks", [
        ...list,
        {
          id: book.id,
          bookName: this.bookTitle(book),
          stockQty: book.stockQty,
          courseId: book.courseId
        }
      ])
    },
    toggleBookSelect(book) {
      if (!book?.id) return
      const stu = this.getActiveStudent()
      if (!stu) return Toast.fail("请先选择学员")
      if (this.isBookSelected(book.id)) {
        this.$set(
          stu,
          "selectedBooks",
          (stu.selectedBooks || []).filter(b => String(b.id) !== String(book.id))
        )
      } else {
        this.addSelectedBookForStudent(stu, book)
      }
    },
    selectApplyStudent(stu) {
      if (stu?.studentId === null || stu?.studentId === undefined || stu?.studentId === "") return
      this.activeStudentId = stu.studentId
      this.refreshBooksForActiveStudent()
    },
    removeApplyStudent(stu) {
      if (stu?.studentId === null || stu?.studentId === undefined || stu?.studentId === "") return
      const studentId = String(stu.studentId)
      this.applyFlow.students = this.applyFlow.students.filter(x => String(x.studentId) !== studentId)
      if (String(this.activeStudentId) === studentId) {
        const first = this.applyFlow.students[0]
        this.activeStudentId = first?.studentId ?? null
        this.refreshBooksForActiveStudent()
      }
    },
    parseStudentBookIds(bookIds) {
      if (bookIds === null || bookIds === undefined) return []
      const list = Array.isArray(bookIds) ? bookIds : []
      return list
        .map(item => {
          if (!item || typeof item !== "object") return null
          const id = item.id ?? item.bookId
          if (id === null || id === undefined || id === "") return null
          const name = (item.name ?? item.bookName ?? item.title ?? "").trim() || "-"
          return {
            id,
            name,
            bookName: name,
            stockQty: item.stockQty,
            courseId: item.courseId ?? null
          }
        })
        .filter(Boolean)
    },
    refreshBooksForActiveStudent() {
      const stu = this.getActiveStudent()
      if (!stu) {
        this.books = []
        return
      }
      const raw = stu.bookIds !== undefined && stu.bookIds !== null ? stu.bookIds : stu.books
      const allBooks = this.parseStudentBookIds(raw)
      const appliedIds = new Set(
        this.parseStudentBookIds(stu.applyBooks).map(book => String(book.id))
      )
      this.books = allBooks.filter(book => !appliedIds.has(String(book.id)))
    },
    buildApplyBookList(selectedBooks) {
      return (selectedBooks || [])
        .map(book => {
          const courseId = book?.courseId
          const bookId = book?.id ?? book?.bookId
          if (courseId === null || courseId === undefined || courseId === "") return null
          if (bookId === null || bookId === undefined || bookId === "") return null
          return {
            courseId: Number(courseId),
            bookId: Number(bookId)
          }
        })
        .filter(Boolean)
    },
    onListTypeChange(type) {
      this.listType = Number(type) || 1
      this.onRecordRefresh(true)
    },
    onRecordStatusChange(status) {
      const next = status === "all" ? "all" : Number(status)
      this.recordStatus = next
      this.onRecordRefresh(true)
    },
    auditStatusText(status) {
      const s = Number(status)
      if (s === 1) return "审批中"
      if (s === 2) return "已同意"
      if (s === 3) return "已拒绝"
      if (s === 4) return "已转交中心"
      if (s === 5) return "部分发放学生"
      if (s === 6) return "已发放学生"
      return "-"
    },
    auditStatusClass(status) {
      const s = Number(status)
      if (s === 2 || s === 4 || s === 5 || s === 6) return "status-approved"
      if (s === 3) return "status-rejected"
      return "status-pending"
    },
    auditCardStatusClass(status) {
      const s = Number(status)
      if (s === 2 || s === 4 || s === 5 || s === 6) return "card-approved"
      if (s === 3) return "card-rejected"
      return "card-pending"
    },
    formatDateOnly(d) {
      const p = n => String(n).padStart(2, "0")
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
    },
    parseDateOnly(v) {
      if (!v) return new Date()
      const m = String(v).replace(/-/g, "/")
      const d = new Date(m)
      return Number.isNaN(d.getTime()) ? new Date() : d
    },
    formatDateTimeToMinute(d) {
      const p = n => String(n).padStart(2, "0")
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    nowToMinuteString() {
      return this.formatDateTimeToMinute(new Date())
    },
    parseDateTime(v) {
      if (!v) return new Date()
      const d = new Date(String(v).replace(/-/g, "/"))
      return Number.isNaN(d.getTime()) ? new Date() : d
    },
    normalizeMinuteText(v) {
      if (!v) return ""
      return this.formatDateTimeToMinute(this.parseDateTime(v))
    },
    toSecondZeroText(v) {
      if (!v) return ""
      const txt = String(v).trim()
      if (!txt) return ""
      return txt.length === 16 ? `${txt}:00` : txt
    },
    buildIssueBookOptions(item, onlyUnissued = false) {
      const list = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      const map = new Map()
      list.forEach(stu => {
        const stuName = (stu?.studentName || "").trim()
        const courseList = Array.isArray(stu?.courseList) ? stu.courseList : []
        courseList.forEach(course => {
          const bookNumList = Array.isArray(course?.bookNumList) ? course.bookNumList : []
          bookNumList.forEach(book => {
            const bid = book?.id
            if (bid === null || bid === undefined || bid === "") return
            if (onlyUnissued && Number(book?.status) !== 0) return
            if (map.has(String(bid))) return
            const bookName = (book?.bookName || "").trim() || `教材${book?.bookId ?? ""}` || "教材"
            map.set(String(bid), {
              id: bid,
              label: stuName ? `${bookName}（${stuName}）` : bookName
            })
          })
        })
      })
      return Array.from(map.values())
    },
    buildIssuedDetailGroups(item) {
      const students = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      return students
        .map((stu, stuIdx) => {
          const studentName = (stu?.studentName || "").trim() || `学员${stu?.studentId ?? stu?.id ?? stuIdx + 1}`
          const courses = Array.isArray(stu?.courseList) ? stu.courseList : []
          const bookList = []
          courses.forEach(course => {
            const bookNumList = Array.isArray(course?.bookNumList) ? course.bookNumList : []
            bookNumList.forEach(book => {
              bookList.push({
                id: book?.id,
                status: Number(book?.status ?? 0),
                bookName: book?.bookName || `教材${book?.bookId ?? ""}` || "-",
                issuedTime: book?.issuedTime || ""
              })
            })
          })
          return {
            key: `${stuIdx}-${stu?.studentId ?? stu?.id ?? "unknown"}`,
            studentName,
            bookList
          }
        })
        .filter(stu => stu.bookList.length > 0)
    },
    issuedStatusText(status) {
      return Number(status) === 1 ? "已发放" : "未发放"
    },
    buildIssueStudentGroups(item, onlyUnissued = false) {
      const students = Array.isArray(item?.applyStudentList) ? item.applyStudentList : []
      return students
        .map((stu, stuIdx) => {
          const studentName = (stu?.studentName || "").trim() || `学员${stu?.studentId ?? stu?.id ?? stuIdx + 1}`
          const courses = Array.isArray(stu?.courseList) ? stu.courseList : []
          const bookList = []
          courses.forEach(course => {
            const bookNumList = Array.isArray(course?.bookNumList) ? course.bookNumList : []
            bookNumList.forEach(book => {
              if (onlyUnissued && Number(book?.status) !== 0) return
              const id = book?.id
              if (id === null || id === undefined || id === "") return
              const bookName = (book?.bookName || "").trim() || `教材${book?.bookId ?? ""}` || "教材"
              bookList.push({ id, label: bookName })
            })
          })
          return {
            key: `${stuIdx}-${stu?.studentId ?? stu?.id ?? "unknown"}`,
            studentName,
            bookList
          }
        })
        .filter(stu => stu.bookList.length > 0)
    },
    allBookIdsOfStudent(stu) {
      const list = Array.isArray(stu?.bookList) ? stu.bookList : []
      return list.map(x => x.id).filter(id => id !== null && id !== undefined && id !== "")
    },
    isStudentAllSelected(stu) {
      const ids = this.allBookIdsOfStudent(stu)
      if (!ids.length) return false
      const selected = new Set(this.issueDialog.selectedIds.map(x => String(x)))
      return ids.every(id => selected.has(String(id)))
    },
    toggleStudentSelectAll(stu) {
      const ids = this.allBookIdsOfStudent(stu)
      if (!ids.length) return
      const selected = new Set(this.issueDialog.selectedIds.map(x => String(x)))
      const allSelected = ids.every(id => selected.has(String(id)))
      if (allSelected) {
        this.issueDialog.selectedIds = this.issueDialog.selectedIds.filter(id => !ids.some(x => String(x) === String(id)))
        return
      }
      const merged = [...this.issueDialog.selectedIds]
      ids.forEach(id => {
        if (!selected.has(String(id))) merged.push(id)
      })
      this.issueDialog.selectedIds = merged
    },
    openIssueDialog(item, onlyUnissued = false) {
      const options = this.buildIssueBookOptions(item, onlyUnissued)
      const groups = this.buildIssueStudentGroups(item, onlyUnissued)
      if (!options.length) {
        Toast.fail(onlyUnissued ? "当前申请单无未发放教材" : "当前申请单无可选教材")
        return
      }
      this.issueDialog.bookOptions = options
      this.issueDialog.studentGroups = groups
      this.issueDialog.selectedIds = []
      this.issueDialog.issuedTime = this.nowToMinuteString()
      this.issueDialog.pickerValue = this.parseDateTime(this.issueDialog.issuedTime)
      this.issueDialog.show = true
    },
    openIssuedDetail(item) {
      this.issuedDetailDialog.groups = this.buildIssuedDetailGroups(item)
      this.issuedDetailDialog.show = true
    },
    closeIssuedDetail() {
      this.issuedDetailDialog.show = false
      this.issuedDetailDialog.groups = []
    },
    openIssuedTimePicker() {
      this.issueDialog.timePickerShow = true
      this.issueDialog.pickerValue = this.parseDateTime(this.issueDialog.issuedTime)
    },
    onConfirmIssuedTime(v) {
      this.issueDialog.issuedTime = this.formatDateTimeToMinute(v)
      this.issueDialog.timePickerShow = false
    },
    onIssuedTimeBlur() {
      this.issueDialog.issuedTime = this.normalizeMinuteText(this.issueDialog.issuedTime)
    },
    closeIssueDialog() {
      this.issueDialog.show = false
      this.issueDialog.timePickerShow = false
      this.issueDialog.bookOptions = []
      this.issueDialog.studentGroups = []
      this.issueDialog.selectedIds = []
      this.issueDialog.issuedTime = ""
    },
    async submitIssueBooks() {
      if (!this.issueDialog.selectedIds.length) return Toast.fail("请选择教材")
      const issuedTime = this.normalizeMinuteText(this.issueDialog.issuedTime)
      if (!issuedTime) return Toast.fail("请选择发放时间")
      this.issueDialog.issuedTime = issuedTime
      const issuedTimeWithSecond = this.toSecondZeroText(issuedTime)
      const idList = this.issueDialog.selectedIds.filter(id => id !== null && id !== undefined && id !== "")
      if (!idList.length) return Toast.fail("所选教材无可发放明细")
      this.issuing = true
      try {
        await issuedBookApply({
          idList,
          issuedTime: issuedTimeWithSecond
        })
        Toast.success("发放成功")
        this.closeIssueDialog()
        this.onRecordRefresh()
      } finally {
        this.issuing = false
      }
    },
    openRecordDateRangePicker() {
      this.recordDateRangePickerShow = true
    },
    onConfirmRecordDateRange(dates) {
      this.recordDateRangePickerShow = false
      const arr = Array.isArray(dates) ? dates : [dates]
      const start = arr[0]
      const end = arr[1] || arr[0]
      this.recordDateRange.start = start ? this.formatDateOnly(start) : ""
      this.recordDateRange.end = end ? this.formatDateOnly(end) : ""
      this.onRecordRefresh()
    },
    clearRecordDateRange() {
      if (!this.recordDateRange.start && !this.recordDateRange.end) return
      this.recordDateRange.start = ""
      this.recordDateRange.end = ""
      this.onRecordRefresh()
    },
    onRecordRefresh(scrollToTop = false) {
      if (scrollToTop) {
        this.scrollToTopAfterLoad = true
        resetPageScrollAfterPaint(this.$el)
      }
      this.recordFinished = false
      this.recordError = false
      this.recordPage = 1
      this.applyRecords = []
      this.recordRefreshing = true
      this.recordLoading = true
      this.onRecordLoad()
    },
    buildRecordListPayload() {
      const payload = {
        createEndTime: this.recordDateRange.end || undefined,
        createStartTime: this.recordDateRange.start || undefined,
        displayLength: this.recordPageSize,
        displayStart: this.recordPage
      }
      const listType = Number(this.listType)
      if (listType === 1) {
        if (this.recordStatus !== "all") {
          payload.status = Number(this.recordStatus)
        }
      } else if (listType === 2) {
        payload.approvalStatusList = [0]
      } else if (listType === 3) {
        payload.approvalStatusList = [1, 2, 3]
      }
      return payload
    },
    async onRecordLoad() {
      this.recordError = false
      try {
        const payload = this.buildRecordListPayload()
        const listType = Number(this.listType)
        const fetchList = listType === 1 ? fetchBookApplyList : fetchBookApplyApprovalList
        const res = await fetchList(payload)
        const list = normalizeList(res)
        if (this.recordRefreshing) this.applyRecords = []
        this.applyRecords = this.applyRecords.concat(list)
        this.recordFinished = list.length < this.recordPageSize
        if (!this.recordFinished) this.recordPage += 1
      } catch (e) {
        this.recordError = true
      } finally {
        this.recordLoading = false
        this.recordRefreshing = false
        if (this.scrollToTopAfterLoad) {
          this.scrollToTopAfterLoad = false
          this.$nextTick(() => resetPageScrollAfterPaint(this.$el))
        }
      }
    },
    resolveTopDepartmentId(staff) {
      const dept = staff?.topDepartment
      if (dept === null || dept === undefined || dept === "") return null
      if (typeof dept === "object") {
        return dept.weId ?? dept.id ?? dept.topDepartmentId ?? null
      }
      return dept
    },
    async ensureLoginStaffInfo() {
      if (this.loginTopDepartmentId || this.loginStaffLoading) return !!this.loginTopDepartmentId
      this.loginStaffLoading = true
      try {
        const cachedId = getCurrentTopDepartmentId()
        if (cachedId !== null && cachedId !== undefined && cachedId !== "") {
          this.loginTopDepartmentId = cachedId
          return true
        }
        const staff = await ensureCurrentStaffProfile()
        const id = this.resolveTopDepartmentId(staff)
        if (id === null || id === undefined || id === "") {
          Toast.fail("未获取到中心信息")
          return false
        }
        this.loginTopDepartmentId = id
        return true
      } catch (e) {
        return false
      } finally {
        this.loginStaffLoading = false
      }
    },
    resetApplyFlow() {
      this.applyFlow.id = null
      this.applyFlow.students = []
      this.applyFlow.remark = ""
      this.activeStudentId = null
      this.books = []
    },
    async openApplyFlow() {
      this.resetApplyFlow()
      const ok = await this.ensureLoginStaffInfo()
      if (!ok) return
      this.applyFlow.show = true
    },
    closeApplyFlow() {
      this.applyFlow.show = false
      this.resetApplyFlow()
    },
    openStudentPicker() {
      this.studentPicker.show = true
      if (!this.studentPicker.list.length) this.searchStudents(true)
    },
    isStudentSelected(studentId) {
      return this.applyFlow.students.some(x => String(x.studentId) === String(studentId))
    },
    toggleStudent(stu) {
      if (stu?.studentId === null || stu?.studentId === undefined || stu?.studentId === "") return
      const studentId = String(stu.studentId)
      if (this.isStudentSelected(studentId)) {
        this.applyFlow.students = this.applyFlow.students.filter(x => String(x.studentId) !== studentId)
        if (String(this.activeStudentId) === studentId) {
          const first = this.applyFlow.students[0]
          this.activeStudentId = first?.studentId ?? null
          this.refreshBooksForActiveStudent()
        }
        return
      }
      const name = (stu.stuName || "").trim() || "-"
      const entry = {
        studentId: stu.studentId,
        label: name,
        selectedBooks: [],
        bookIds: stu.bookIds ?? stu.books ?? null,
        applyBooks: stu.applyBooks ?? null
      }
      this.applyFlow.students = [...this.applyFlow.students, entry]
      this.activeStudentId = entry.studentId
      this.refreshBooksForActiveStudent()
    },
    confirmStudentPicker() {
      if (!this.activeStudentId && this.applyFlow.students.length) {
        this.activeStudentId = this.applyFlow.students[0].studentId
      }
      this.studentPicker.show = false
      this.refreshBooksForActiveStudent()
    },
    onStudentKeywordInput() {
      if (this.studentPicker.keywordTimer) clearTimeout(this.studentPicker.keywordTimer)
      this.studentPicker.keywordTimer = setTimeout(() => this.searchStudents(true), 350)
    },
    onStudentSearch() {
      this.searchStudents(true)
    },
    onStudentPickerLoad() {
      this.searchStudents(false)
    },
    async searchStudents(reset = false) {
      if (reset) {
        this.studentPicker.page = 1
        this.studentPicker.finished = false
        this.studentPicker.list = []
      }
      if (this.studentPicker.requesting || this.studentPicker.finished) {
        this.studentPicker.loading = false
        return
      }
      this.studentPicker.loading = true
      this.studentPicker.requesting = true
      try {
        const keyword = (this.studentPicker.keyword || "").trim()
        const res = await fetchBookApplyStudentCourse({
          displayStart: this.studentPicker.page,
          displayLength: this.studentPicker.pageSize,
          allName: keyword || undefined
        })
        const list = Array.isArray(res?.data) ? res.data : normalizeList(res)
        this.studentPicker.list = this.studentPicker.list.concat(list)
        this.studentPicker.finished = list.length < this.studentPicker.pageSize
        if (!this.studentPicker.finished) this.studentPicker.page += 1
      } finally {
        this.studentPicker.requesting = false
        this.studentPicker.loading = false
      }
    },
    async approveAudit(item) {
      const id = item?.id || item?.applyId
      if (!id) return Toast.fail("缺少审批单ID")
      this.approvingId = id
      try {
        await approveBookApplyPass({ id, rejectReason: "" })
        Toast.success("已同意")
        this.onRecordRefresh()
      } finally {
        this.approvingId = ""
      }
    },
    rejectAudit(item) {
      const id = item?.id || item?.applyId
      if (!id) return Toast.fail("缺少审批单ID")
      this.auditRejectDialog.id = id
      this.auditRejectDialog.reason = ""
      this.auditRejectDialog.show = true
    },
    async onConfirmAuditReject() {
      const id = this.auditRejectDialog.id
      if (!id) return Toast.fail("缺少审批单ID")
      const remark = (this.auditRejectDialog.reason || "").trim()
      this.rejectingId = id
      try {
        await approveBookApplyReject({ id, rejectReason: remark })
        Toast.success("已拒绝")
        this.auditRejectDialog.show = false
        this.auditRejectDialog.id = ""
        this.auditRejectDialog.reason = ""
        this.onRecordRefresh()
      } finally {
        this.rejectingId = ""
      }
    },
    openToCenterDialog(item) {
      const id = item?.id || item?.applyId
      if (!id) return Toast.fail("缺少审批单ID")
      this.toCenterDialog.id = id
      this.toCenterDialog.toCenterTime = this.nowToMinuteString()
      this.toCenterDialog.pickerValue = this.parseDateTime(this.toCenterDialog.toCenterTime)
      this.toCenterDialog.show = true
    },
    openToCenterTimePicker() {
      this.toCenterDialog.timePickerShow = true
      this.toCenterDialog.pickerValue = this.parseDateTime(this.toCenterDialog.toCenterTime)
    },
    onConfirmToCenterTime(v) {
      this.toCenterDialog.toCenterTime = this.formatDateTimeToMinute(v)
      this.toCenterDialog.timePickerShow = false
    },
    onToCenterTimeBlur() {
      this.toCenterDialog.toCenterTime = this.normalizeMinuteText(this.toCenterDialog.toCenterTime)
    },
    async submitToCenter() {
      const id = this.toCenterDialog.id
      if (!id) return Toast.fail("缺少审批单ID")
      const toCenterTime = this.normalizeMinuteText(this.toCenterDialog.toCenterTime)
      if (!toCenterTime) return Toast.fail("请输入转交时间")
      this.toCenterDialog.toCenterTime = toCenterTime
      const toCenterTimeWithSecond = this.toSecondZeroText(toCenterTime)
      this.centeringId = id
      try {
        await toCenterBookApply({ id, toCenterTime: toCenterTimeWithSecond })
        Toast.success("已转交中心")
        this.toCenterDialog.show = false
        this.toCenterDialog.id = ""
        this.onRecordRefresh()
      } finally {
        this.centeringId = ""
      }
    },
    async submitApply() {
      const staffOk = await this.ensureLoginStaffInfo()
      if (!staffOk) return
      if (!this.canSubmitApply) {
        if (!this.applyFlow.students.length) return Toast.fail("请选择学员")
        const missing = this.applyFlow.students.find(stu => !(stu.selectedBooks?.length))
        if (missing) return Toast.fail(`请为「${missing.label}」选择教材`)
        return
      }

      const payload = {
        topDepartmentId: this.loginTopDepartmentId,
        remark: (this.applyFlow.remark || "").trim() || undefined,
        applyStudentList: this.applyFlow.students.map(stu => ({
          studentId: stu.studentId,
          bookList: this.buildApplyBookList(stu.selectedBooks)
        }))
      }

      this.applyFlow.submitting = true
      Toast.loading({ message: "提交中...", forbidClick: true, duration: 0 })
      try {
        await applyBookStock(payload)
        Toast.clear()
        Toast.success("申请成功")
        this.closeApplyFlow()
        this.onRecordRefresh()
      } catch (e) {
        Toast.clear()
      } finally {
        this.applyFlow.submitting = false
      }
    }
  }
}
</script>

<style src="@/styles/approval-status.css"></style>
<style scoped>
.material-page {
  min-height: 100vh;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(110px + var(--app-safe-area-bottom, 0px));
}

.record-list-wrap {
  flex: 1;
  padding: 0;
}

.record-top {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  padding-top: 4px;
}

.record-filters {
  background: #fff;
}

.date-filter {
  padding: 0 12px 4px;
  background: #fff;
}

.date-row {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 2px;
}

.date-label {
  font-size: 13px;
  color: #969799;
  flex: 0 0 auto;
}

.date-value {
  font-size: 13px;
  color: #323233;
  padding: 1px 5px;
  border-radius: 6px;
  background: #f7f8fa;
}

.date-sep {
  color: #969799;
  flex: 0 0 auto;
}

.date-clear {
  margin-left: 6px;
  font-size: 12px;
  color: rgb(242, 124, 52);
  flex: 0 0 auto;
}

:deep(.van-tab--active) {
  color: rgb(242, 124, 52);
}

:deep(.van-tabs__line) {
  background: rgb(242, 124, 52);
}

:deep(.van-tabs__wrap) {
  height: 34px;
}

.records-wrap {
  margin-top: 8px;
  padding: 0 12px;
}

.record-card {
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(30, 35, 90, 0.05);
}

.record-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.record-card-title-wrap {
  flex: 1;
  min-width: 0;
}

.record-card-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.record-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #323233;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-card-body {
  margin-top: 8px;
}

.record-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-top: 6px;
  gap: 12px;
}

.record-actions {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.record-cancel-btn,
.record-issue-btn,
.record-detail-btn {
  height: 36px;
}

.record-issue-btn {
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.record-label {
  color: #969799;
  flex-shrink: 0;
}

.record-value {
  color: #323233;
  text-align: right;
  word-break: break-all;
}

.record-card-foot {
  margin-top: 8px;
  font-size: 12px;
  color: #c8c9cc;
}

.record-books-block {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}

.record-section-title {
  font-size: 12px;
  color: #969799;
  margin-bottom: 6px;
}

.record-student-block + .record-student-block {
  margin-top: 8px;
}

.record-student-title {
  font-size: 13px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 6px;
}

.record-course-books {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.record-book-chip {
  display: inline-block;
  padding: 2px 7px;
  border-radius: 12px;
  font-size: 11px;
  color: rgb(242, 124, 52);
  background: rgba(242, 124, 52, 0.1);
  border: 1px solid rgba(242, 124, 52, 0.2);
}

.panel-empty {
  padding: 44px 0;
  background: transparent;
}

.page-bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--app-tabbar-offset, 50px);
  padding: 10px 12px;
  background: #fff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.06);
  z-index: 90;
}

.theme-btn {
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.apply-flow-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebedf0;
  flex-shrink: 0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.apply-flow-form {
  flex-shrink: 0;
}

.apply-picker-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
  border-top: 1px solid #ebedf0;
}

.student-panel {
  width: 36%;
  max-width: 140px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-right: 1px solid #ebedf0;
  overflow: hidden;
}

.student-side-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 0 6px 8px;
}

.student-side-list :deep(.van-empty) {
  padding: 12px 0;
}

.student-side-list :deep(.van-empty__image) {
  width: 64px;
  height: 64px;
}

.student-side-list :deep(.van-empty__description) {
  font-size: 12px;
  line-height: 1.4;
  padding: 0 4px;
}

.student-side-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.student-item-content {
  flex: 1;
  min-width: 0;
}

.student-remove-icon {
  flex-shrink: 0;
  font-size: 16px;
  color: #c8c9cc;
  padding: 2px;
  margin-top: 1px;
}

.student-panel-foot {
  flex-shrink: 0;
  padding: 8px 6px 10px;
  border-top: 1px solid #f0f0f0;
  overflow: hidden;
}

.student-panel-foot :deep(.van-button) {
  width: 100%;
  box-sizing: border-box;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 11px;
  color: #969799;
  line-height: 1.3;
  word-break: break-all;
}

.book-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f7f8fa;
}

.book-panel-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.book-panel-head {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 10px 8px;
  background: #f7f8fa;
  border-bottom: 1px solid #ebedf0;
}

.book-panel-head .panel-title {
  padding: 0;
}

.select-all-check {
  flex-shrink: 0;
  font-size: 12px;
  color: #646566;
}

.panel-title {
  padding: 10px 10px 6px;
  font-size: 13px;
  font-weight: 600;
  color: #323233;
}

.panel-subtitle {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  font-weight: 400;
  color: #969799;
}

.panel-loading,
.panel-hint {
  padding: 20px 10px;
  text-align: center;
  color: #969799;
  font-size: 13px;
}

.panel-empty {
  padding: 20px 0;
}

.course-list {
  flex: 1;
  overflow: hidden;
  padding: 0 6px 8px;
}

.course-item {
  padding: 10px 6px;
  margin-bottom: 6px;
  border-radius: 8px;
  background: #f7f8fa;
}

.course-item.active {
  background: rgba(242, 124, 52, 0.12);
  border: 1px solid rgba(242, 124, 52, 0.35);
}

.course-item-name {
  font-size: 13px;
  font-weight: 600;
  color: #323233;
  line-height: 1.4;
  word-break: break-all;
}

.book-list {
  margin: 0 8px 8px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.book-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  min-height: 42px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.book-row:last-child {
  border-bottom: none;
}

.book-row.selected {
  background: rgba(242, 124, 52, 0.12);
}

.book-check {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin: 0;
}

.book-check :deep(.van-checkbox__icon) {
  line-height: 1;
}

.book-row-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-row-stock {
  flex-shrink: 0;
  font-size: 12px;
  color: rgb(242, 124, 52);
  font-weight: 500;
}

.book-row-stock::before {
  content: "库存 ";
  color: #969799;
  font-weight: 400;
}

.apply-flow-footer {
  flex-shrink: 0;
  border-top: 1px solid #ebedf0;
  background: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}

.apply-footer-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
}

.apply-selected-tip {
  font-size: 13px;
  color: #646566;
  flex-shrink: 0;
}

.apply-submit-btn {
  flex: 1;
  max-width: 160px;
}

.student-picker-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.student-list-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 16px;
}

.student-item {
  padding: 12px;
  margin-bottom: 8px;
  background: #f7f8fa;
  border-radius: 8px;
}

.student-item.active {
  background: rgba(242, 124, 52, 0.1);
  border: 1px solid rgba(242, 124, 52, 0.35);
}

.student-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
}

.student-item-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #969799;
}

.student-picker-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 12px 16px calc(12px + var(--app-safe-area-bottom, 0px));
  border-top: 1px solid #ebedf0;
  background: #fff;
  flex-shrink: 0;
}

.student-picker-tip {
  font-size: 14px;
  color: #646566;
  text-align: center;
}

.student-picker-confirm-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 600;
}

.issue-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.popup-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #ebedf0;
}

.popup-title {
  font-size: 16px;
  font-weight: 600;
}

.popup-close {
  font-size: 18px;
  color: #969799;
}

.issue-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.issue-section-title {
  margin: 10px 12px 6px;
  font-size: 13px;
  color: #969799;
}

.issue-student-list {
  padding: 0 12px 12px;
}

.issue-group-block {
  padding: 8px 0 2px;
}

.issue-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.issue-group-title {
  font-size: 13px;
  color: #323233;
  font-weight: 600;
  margin-bottom: 6px;
}

.issue-select-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  font-size: 12px;
  color: #646566;
}

.issue-select-icon {
  font-size: 16px;
  color: #1989fa;
}

.issue-student-item {
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
}

.issue-student-item:last-child {
  border-bottom: none;
}

.issued-detail-item {
  background: #fff;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.issued-detail-item-issued {
  background: rgba(34, 160, 107, 0.06);
  border-color: rgba(34, 160, 107, 0.28);
}

.issued-detail-item-unissued {
  background: rgba(245, 158, 11, 0.06);
  border-color: rgba(245, 158, 11, 0.28);
}

.issued-status-issued {
  color: #22a06b;
  font-weight: 600;
}

.issued-status-unissued {
  color: #f59e0b;
  font-weight: 600;
}

:deep(.issue-student-list .van-checkbox) {
  display: flex;
  align-items: center;
}

:deep(.issue-student-list .van-checkbox__icon) {
  font-size: 16px;
  line-height: 1;
}

:deep(.issue-student-list .van-checkbox__label) {
  margin-left: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  word-break: break-all;
}

.issue-footer {
  flex-shrink: 0;
  border-top: 1px solid #ebedf0;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  background: #fff;
}

.audit-actions {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.audit-actions.single-action .action-btn {
  max-width: 100%;
}

.action-btn {
  flex: 1;
  height: 40px;
}

.action-btn-approve {
  color: #fff;
  background: rgb(242, 124, 52);
  border-color: rgb(242, 124, 52);
}

.action-btn-reject {
  color: #ee0a24;
  border-color: #ee0a24;
}

.reject-dialog-body {
  padding: 10px 12px 0;
}
</style>
